<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/standard/doc/attach/files/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <!--          {{$attrs.appendix.materialId}}-->
          <el-form-item class="noborder" :label="$t('biaozhunwendangmingcheng')">
            <el-input disabled v-model="$attrs.appendix.docName"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
            <yi_cross_select disabled :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="$attrs.appendix.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongxumiaoshu')">
            <el-input disabled v-model="desc"></el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 抽样类型 -->
      <template #chouyangleixing="scope">
        <span v-if="scope.row.samplingType == 1">{{ $t('chouyangfangan') }}</span>
        <span v-if="scope.row.samplingType == 2">{{ $t('100%chouyang') }}</span>
        <span v-if="scope.row.samplingType == 3">{{ $t('gudingchouyang') }}</span>
        <span v-if="scope.row.samplingType == 4">{{ $t('anbaifenbichouyang') }}</span>
      </template>
      <!-- 严格度 -->
      <template #yangedu="scope">
        <span v-if="scope.row.level == 1">{{ $t('zhengchang') }}</span>
        <span v-if="scope.row.level == 2">{{ $t('fangkuan') }}</span>
        <span v-if="scope.row.level == 3">{{ $t('jiayan') }}</span>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <yi_upload ref="upload" :isShowFiles="false" v-if="$attrs.appendix.latest === true" :accept="'image/png, image/jpeg,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,video/mp4,video/avi,video/mpeg'" :ids.sync="fileIds" :limit="1">
          <div slot="limitMsg"></div>
        </yi_upload>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button :loading="scope.row.loading" @click="downFile(scope.row)" type="text">{{ $t('xiazai') }}</el-button>
          </el-col>
          <el-col :span="0.1" v-if="$attrs.appendix.latest === true">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/quality/standard/doc/attach/files/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 导入excel -->
    <!-- <import-excel :show.sync="show" /> -->
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_quality_management_standard_doc_standard_appendix',
  components: {
    // importExcel
  },
  data() {
    return {
      fileIds: [],
      desc: null,
      planCodeList: [],
      show: false,
      exceptionTypeList: [],
      columns: [
        {
          label: 'wenjianmingcheng',
          prop: 'fileInfo.name',
          width: 180
        },
        {
          label: 'wenjiangeshi',
          prop: 'fileInfo.name',
          //格式化，取值为fileInfo.name的后缀名
          formatter: ((value) => {
            const fileName = value.row.fileInfo.name;
            return fileName.split('.').pop();
          }),
          width: 100
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
          // width: 130,
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    fileIds: {
      handler(n) {
        if (n) {
          this.getFile();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        standardDocId: this.$attrs.appendix.id
      };
      this.yt.get(1);
    }, 300);
  },
  mounted() {
    if (this.$attrs.appendix.basicWorkProcedure) {
      this.desc = this.$attrs.appendix.basicWorkProcedure.desc;
    } else {
      this.desc = '';
    }
  },
  methods: {
    // 下载文件
    downFile(row) {
      this.$set(row, 'loading', true);
      this.http
        .get('/web/customer/files/download?id=' + row.fileInfoId)
        .then(res => {
          let baseUrl = res.data;
          this.$set(row, 'loading', false);
          if (res.data) {
            // 判断文件类型是否为视频
            const videoExtensions = ['mp4', 'avi', 'mpeg'];
            const fileExtension = baseUrl.split('.').pop().toLowerCase();
            if (videoExtensions.includes(fileExtension)) {
              // 弹窗播放视频
              this.$alert(`<video controls width="640" height="360"><source src="${baseUrl}" type="video/${fileExtension}">Your browser does not support the video tag.</video>`, '播放视频', {
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnClickModal: true,
                closeOnPressEscape: true,
                customClass: 'video-dialog'
              });
            } else {
              // 下载文件
              window.open(baseUrl);
            }
          }
        })
        .catch(err => {
          this.$set(row, 'loading', false);
        });
    },
    getPlanCode() {
      this.http
        .get('web/quality/sampling/plan/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.planCodeList = res.data.rows;
        });
    },
    getFile() {
      let params = {
        standardDocId: this.$attrs.appendix.id,
        fileInfoId: this.fileIds,
        fileExtension: '1',
        fileName: this.$t('wenjianming')
      };
      this.http.post('web/quality/standard/doc/attach/files/create', params).then(res => {
        this.yt.get(1);
        this.$refs.upload.remove(0);
      });
    }
  }
};
</script>
